'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isServerRendering = isServerRendering;
exports.maxMobileWidth = maxMobileWidth;
exports.windowWidth = windowWidth;
exports.isMobile = isMobile;
function isServerRendering() {
  return typeof window === 'undefined';
}

function maxMobileWidth() {
  return 768;
}

function windowWidth() {
  if (!isServerRendering()) {
    return window.innerWidth;
  }
  return null;
}

function isMobile() {
  var width = windowWidth();
  if (width == null) return null;
  return width <= maxMobileWidth();
}


//////////////////
// WEBPACK FOOTER
// ./~/frontend_core/dist/helpers/screen.js
// module id = 836
// module chunks = 0